"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShowFields = getShowFields;
exports.setShowFields = setShowFields;
exports.getFilterFields = getFilterFields;
exports.setFilterFields = setFilterFields;
exports.filterNullList = filterNullList;
exports.downloadFile = downloadFile;
exports.list2Tree = list2Tree;
exports.treeList2Map = treeList2Map;
exports.getTreeLastLevel = getTreeLastLevel;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getShowFields(name, allColumns) {
  var cols = localStorage.getItem('showFields' + name);

  if (cols) {
    return JSON.parse(cols);
  }

  var out = [];
  allColumns.forEach(function (col) {
    if (col.children && Array.isArray(col.children)) {
      col.children.forEach(function (c) {
        out.push((col.dataIndex || col.key) + '.' + (c.dataIndex || col.key));
      });
    } else {
      out.push(col.dataIndex || col.key);
    }
  });
  return out;
}

function setShowFields(name, columns) {
  localStorage.setItem('showFields' + name, JSON.stringify(columns));
}

function getFilterFields(name) {
  var cols = localStorage.getItem('filterFields' + name);

  if (cols) {
    return JSON.parse(cols) || [];
  }

  return [];
}

function setFilterFields(name, filterFields) {
  localStorage.setItem('filterFields' + name, JSON.stringify(filterFields));
}

function filterNullList(obj) {
  var out;

  if (Array.isArray(obj)) {
    out = obj.filter(function (v) {
      return v;
    }).map(function (v) {
      if ((0, _typeof2.default)(v) === 'object') {
        return filterNullList(v);
      }

      return v;
    });
  } else if ((0, _typeof2.default)(obj) === 'object' && obj) {
    out = {};
    Object.keys(obj).forEach(function (key) {
      var value = obj[key];

      if ((0, _typeof2.default)(value) === 'object') {
        out[key] = filterNullList(value);
      } else {
        out[key] = value;
      }
    });
  } else {
    return obj;
  }

  return out;
}

function downloadFile(data) {
  var fileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'excel.xlsx';

  if (!data) {
    return;
  }

  var url = window.URL.createObjectURL(new Blob([data]));
  var link = document.createElement('a');
  link.style.display = 'none';
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
}

function list2Tree(l) {
  var list = JSON.parse(JSON.stringify(l));
  list.forEach(function (item) {
    if (item.parentId) {
      list.every(function (item2) {
        if (item2.value === item.parentId) {
          if (!item2.children) {
            item2.children = [];
          }

          item2.children.push(item);
          item.parent = item2;
        }

        return true;
      });
    }
  });
  return list.filter(function (item) {
    return !item.parent;
  });
}

function treeList2Map(list) {
  var parentName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var result = [];
  list.forEach(function (item) {
    var labelList = [].concat((0, _toConsumableArray2.default)(parentName), [item.label]);

    if (item.children) {
      result.push.apply(result, (0, _toConsumableArray2.default)(treeList2Map(item.children, labelList)));
    } else {
      result.push({
        label: labelList.join('/'),
        value: item.value
      });
    }
  });
  return result;
}

function getTreeLastLevel(list) {
  var result = [];
  list.forEach(function (item) {
    if (item.children) {
      result.push.apply(result, (0, _toConsumableArray2.default)(getTreeLastLevel(item.children)));
    } else {
      result.push(_objectSpread({}, item));
    }
  });
  return result;
}